"use client";

import { InboundGptMarketingShell } from "~/components/inbound-gpt/inbound-gpt-marketing-shell";
import { MarketingAttributionCapture } from "~/components/siteglue/marketing-attribution-capture";
import { useMarketingPageTracking } from "~/hooks/use-marketing-page-tracking";

export function MarketingPublicLayoutClient({
  children,
  scannerHost = false,
  brandId,
}: {
  children: React.ReactNode;
  scannerHost?: boolean;
  brandId?: "siteglue" | "inbound_gpt";
}) {
  useMarketingPageTracking();
  return (
    <>
      <MarketingAttributionCapture />
      <InboundGptMarketingShell scannerHost={scannerHost} brandId={brandId}>
        {children}
      </InboundGptMarketingShell>
    </>
  );
}
